import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all form input types
export const getFormInputType = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-input-type`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-input-type:", error.response?.data || error);
    throw error;
  }
};

// GET a single form input type
export const getFormInputTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-input-type/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-input-type:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new form input type
export const createFormInputType = async (formInputTypeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/form-input-type`, formInputTypeData);
    return response.data;
  } catch (error) {
    console.error("Error creating form-input-type:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing form input type
export const updateFormInputType = async (id, formInputTypeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/form-input-type/${id}`, formInputTypeData);
    return response.data;
  } catch (error) {
    console.error("Error updating form-input-type:", error.response?.data || error);
    throw error;
  }
};

// DELETE a form input type
export const deleteFormInputType = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/form-input-type/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting form-input-type:", error.response?.data || error);
    throw error;
  }
};
